import {
  MarkerType,
  getMarkerFormattersHTML,
  markerFormattersURL,
} from '@apps/main/modules/maps/markerFormatters';

import type { MapTypeId, Marker, MarkerFormatter, Rectangle } from '@libs/maps';

import type { HotelStaticData } from '../models';
import { MapType } from '../../maps';

export function getInitialMapView(
  hotelDetails: HotelStaticData | undefined
): Rectangle | undefined {
  if (!hotelDetails) {
    return;
  }

  const position = hotelDetails.staticInfo.position;
  const shift = 0.01;

  return {
    topLeft: {
      longitude: position.longitude.decimalDegrees - shift,
      latitude: position.latitude.decimalDegrees + shift,
    },
    bottomRight: {
      longitude: position.longitude.decimalDegrees + shift,
      latitude: position.latitude.decimalDegrees - shift,
    },
  };
}

export function getMapMarker(
  hotelDetails: HotelStaticData | undefined
): Marker | undefined {
  if (!hotelDetails) {
    return;
  }

  const { latitude, longitude } = hotelDetails.staticInfo.position;
  const ingredientId = hotelDetails.staticInfo.ingredientId;

  return {
    key: hotelDetails.hotelCode,
    position: {
      latitude: latitude.decimalDegrees,
      longitude: longitude.decimalDegrees,
    },
    data: { ingredientId },
    useContentFormatter: MarkerType.DetailsAccommodation,
  };
}

export function getMapMarkerFormatters(
  mapType: MapType.Static
): Partial<MarkerFormatter>;
export function getMapMarkerFormatters(
  mapType: MapType.Dynamic,
  mapTypeId: MapTypeId
): Partial<MarkerFormatter>;
export function getMapMarkerFormatters(
  mapType: MapType,
  mapTypeId?: MapTypeId
): Partial<MarkerFormatter> {
  switch (mapType) {
    case MapType.Static:
      return markerFormattersURL;
    case MapType.Dynamic:
      if (!mapTypeId) {
        throw new Error('mapTypeId is required for Dynamic maps');
      }
      return getMarkerFormattersHTML(mapTypeId);
    default:
      throw new Error('Invalid map type');
  }
}
